<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box" style="left:0;">
        <div class="xblock layui-form">
          <div class="layui-input-inline country_select xblock-row">
            <select name="status" lay-verify="required" lay-filter="status_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.name" v-for="(item,index) in status" v-bind:key="index"></option>
            </select>
          </div>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <div class="table-box-list">
          <table class="layui-table layui-table-margin">
            <thead>
              <tr>
                <th style="width: 80px;">图片</th>
                <th>仓库</th>
                <th v-if="role != 30">UID</th>
                <th>方式</th>
                <th>订单号</th>
                <th>商品快递</th>
                <th>规格</th>
                <th>状态</th>
                <th>退回单号</th>
                <th>地址&取件码</th>
                <th>时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
                <td>
                  <div class="table_img col-img" :style="{'background-image': 'url('+item.item_data.img+')'}">
                    <img class="viewerimg" :src="item.item_data.img">
                  </div>
                </td>
                <td>
                  <div style="width: 45px;">
                    <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                  </div>
                </td>
                <td v-if="role != 30" v-text="item.uid"></td>
                <td>
                  <div style="width: 65px;">
                    <i v-if="item.return_type == 0">快递寄送</i>
                    <i v-else>上门取件</i>
                  </div>
                </td>
                <td v-text="item.order_sn"></td>
                <td>
                  <i v-for="log in item.item_data.shipment_number" v-text="log.number"></i>
                </td>
                <td v-text="item.item_data.variation_name"></td>
               <td>
                  <div style="width: 80px;">
                    <i v-if="item.shipment_number" class="status-box status-box-green">已完成</i>
                    <i v-else class="status-box status-box-red">处理中</i>
                  </div>
                </td>
                <td>
                  <i v-if="item.return_type == 0 && item.shipment_number" v-text="item.shipment_number"></i>
                  <i v-else>-</i>
                </td>
                <td>
                  <i v-if="item.return_type == 0" v-text="item.addr"></i>
                  <i v-else v-text="item.pick_up_code"></i>
                </td>
                <td v-text="item.created_at"></td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="UserReturnPro(item)" v-if="role == 30">编辑</button>
                  <button class="layui-btn" v-on:click="ReturnPro(item)" v-else>编辑</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="DeleteItme(item.id)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

      <!-- 确认框 -->
      <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    </div>
  </div>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'ConsumptionRecord',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        uid:null,
        role:null,
        isLoding: false,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num: 20,
        current_status: 0,
        statu_id:null,
        list: [],
        itemid:null,
        status: [{
          id: 1,
          name: "处理中"
        }, {
          id: 2,
          name: "已完成"
        }],
        warehouseList:warehouseList
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("货代",self.$route.name);
      self.uid = localStorage.getItem("ExShopee_id");
      self.role = localStorage.getItem("ExShopee_Role");

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        form.on('select(status_selection)', function(data) {
          self.current_status = data.value;
          self.statu_id = data.value;
          self.get_return_list(true)
        });

        //退货方式
        form.on('radio(returnType)', function(data) {
          if(data.value == 0){
            $(".pickupCode").hide();
            $(".returnInfo").show();
          }else{
            $(".pickupCode").show();
            $(".returnInfo").hide();
          }
        });

        form.render('select');

        self.get_return_list()
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_return_list(state) {
        if(state){
          self.list = [];
        }
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        param.append('warehouse', self.uid-1)
        if(self.statu_id && self.statu_id > 0){
          param.append('etype', self.statu_id)
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/item_return_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              var list = datas.list;
              for (let item in list) {
                if (list[item].item_data) {
                  list[item].item_data = JSON.parse(list[item].item_data);
                }
              }
              self.list = list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "get_return_list"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      UserReturnPro(item) {
        var w, h;
        let l = $(".page-content").offset().left + 20;
        if (w == null || w == '') {
          w = $(window).width() - l - 20;
          if (w > 1000) {
            w = 1000;
          }
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        let ReturnProBox = layer.open({
          type: 1,
          offset: '100px',
          title: "申请退货",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: ReturnProHtml,
          success: function() {
            if(item.return_type == 0){
              $(".pickupCode").hide();
              $(".returnInfo").show();
            }else{
              $(".pickupCode").show();
              $(".returnInfo").hide();
            }
            console.log(item.warehouse)
            $("#returnType input[name=returnType][value='"+item.return_type+"']").prop("checked", "true");
            $("#returnInfo").val(item.addr);
            $("#pickupCode").val(item.pick_up_code);
            $("#warehouse").val(item.warehouse);
            form.render();
          },
          yes: function(index, layero) {
            var returnType = $('#returnType input[name="returnType"]:checked').val();
            var returnInfo = $("#returnInfo").val();
            var pickupCode = $("#pickupCode").val();
            var warehouse = $("#warehouse").val();
            let param = new URLSearchParams()
            param.append('id', item.id)
            param.append('order_sn', item.order_sn)
            param.append('uid', item.uid)
            param.append('item_id', item.item_data.item_id)
            param.append('return_type', returnType)
            param.append('warehouse', warehouse)
            param.append('item_data', JSON.stringify(item.item_data))
            if (returnType == 0) {
              param.append('addr', returnInfo)
              if (!returnInfo) {
                layer.msg("退货信息不能为空！");
                return;
              }
            } else {
              param.append('pick_up_code', pickupCode)
              if (!pickupCode) {
                layer.msg("取件码不能为空！");
                return;
              }
            }
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/item_return/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                layer.close(ReturnProBox);
                self.get_return_list();
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              layer.msg(error); //弹窗提醒
            })
          }
        });

      },
      ReturnPro(item) {
        if(item.return_type == 1){  //上门取件
          let box = layer.confirm('是否确认已完成退货？', {
            btn: ['确定','取消'] //按钮
          }, function(){
            let param = new URLSearchParams()
            param.append('id', item.id)
            param.append('uid', item.uid)
            param.append('order_sn', item.order_sn)
            param.append('shipment_number', 666)
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/item_return/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                layer.close(box);
                self.get_return_list();
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              layer.msg(error); //弹窗提醒
            })
          });

        }else{  //快递寄送
          var w, h;
          let l = $(".page-content").offset().left + 20;
          if (w == null || w == '') {
            w = $(window).width() - l - 20;
            if (w > 1000) {
              w = 1000;
            }
          };
          if (h == null || h == '') {
            h = $(window).height() - 200;
          };
          let ReturnProBox = layer.open({
            type: 1,
            offset: '100px',
            title: "回填退货单号",
            area: [w + 'px', h + 'px'],
            fixed: false, //不固定
            btn: ['确定', '取消'],
            content: ReturnFinishHtml,
            success: function() {

              form.render();
            },
            yes: function(index, layero) {
              var is_cost = $('#is_cost input[name="is_cost"]:checked').val();
              var return_area = $("#return_area").val();
              var log_company = $("#log_company").val();
              var overweight = $("#overweight").val();
              var log_code = $("#log_code").val();

              let param = new URLSearchParams()
              param.append('id', item.id)
              param.append('uid', item.uid)
              param.append('is_cost', is_cost)
              param.append('order_sn', item.order_sn)
              param.append('return_area', return_area)
              param.append('log_company', log_company)
              param.append('extra_fee', overweight)
              param.append('shipment_number', log_code)
              if (!log_code) {
                layer.msg("快递单号不能为空！");
                return;
              }
              self.loading = true;
              axios({
                method: 'post',
                url: self.GetServerUrl() + "/item_return/",
                data: param,
                headers: {
                  'token': localStorage.getItem("ExShopee_token")
                }
              }).then(function(response) {

                //返回数据处理
                self.ReturnFuntion(self, response, function(datas) {
                  layer.close(ReturnProBox);
                  self.get_return_list();
                }, false, true);

              }).catch(function(error) {
                self.loading = false;
                layer.msg(error); //弹窗提醒
              })
            }
          });
        }
      },
      DeleteItme(id) {
        self.Confirm.txt = "是否确认删除？"
        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.itemid = id;
      },
      ConfirmBackFun(data) {

        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          self.Confirm.state = false;
          $.ajax({
            url: self.GetServerUrl() + "/item_return_del/",
            type: 'post',
            data: {
              id: self.itemid
            },
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              var json = JSON.parse(res);
              layer.msg(json.msg);
              if (json.code == 200) {
                self.get_return_list();
              }
            },
            error: function(error) {
              self.loading = false;
              layer.msg(error);
            }
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }
  .country_select {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/Return.vue